import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'taxonomy-product_language_option_atc-success';

/**
 * Successfully add to cart, with a selected Product Language product option.
 */
export function trackTaxonomyProductLanguageOptionAtcSuccess(
  Option_Language_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { Option_Language_string },
  });
}
